/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommJobDetailsData } from './ecomm-job-details.data';
import { IEcommJobDetailsProps } from './ecomm-job-details.props.autogenerated';

export interface IEcommJobDetailsViewProps extends IEcommJobDetailsProps<IEcommJobDetailsData> {
    intro: React.ReactNode;
    description: React.ReactNode;
    requirements: React.ReactNode;
}

/**
 *
 * EcommJobDetails component
 * @extends {React.PureComponent<IEcommJobDetailsProps<IEcommJobDetailsData>>}
 */
class EcommJobDetails extends React.PureComponent<IEcommJobDetailsProps<IEcommJobDetailsData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const intro = config.intro && (
            <MsDyn365.RichTextComponent
                text={config.intro}
                editProps={{
                    onEdit: this._handleIntroChange,
                    requestContext: this.props.context.request
                }}
            />
        );
        const description = config.description && (
            <MsDyn365.RichTextComponent
                text={config.description}
                editProps={{
                    onEdit: this._handleDescriptionChange,
                    requestContext: this.props.context.request
                }}
            />
        );
        const requirements = config.requirements && (
            <MsDyn365.RichTextComponent
                text={config.requirements}
                editProps={{
                    onEdit: this._handleRequirementsChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const EcommJobDetailsViewProps = {
            ...this.props,
            intro: intro,
            description: description,
            requirements: requirements
        };

        return this.props.renderView(EcommJobDetailsViewProps);
    }

    private _handleIntroChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.intro = event.target.value);

    private _handleDescriptionChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);

    private _handleRequirementsChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.requirements = event.target.value);
}

export default EcommJobDetails;
